<template>
    <modal name="moneyboxToEmployeeChargeModal" width="80%" height="50%" @opened="moneyboxFullCharge" @closed="resetForm">
        <div class="p-2">
            <h2 class="text-center">Введите сумму для начисления сотруднику из копилки:</h2>
            <div class="row justify-content-center">
                <h3>{{ moneyboxEmployee.chosenName }}</h3>
            </div>
            <div class="row justify-content-center p-1">
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label class="form-check-label" for="moneybox">В копилке:</label>
                        <input type="text" class="form-control" id="moneybox" name="moneybox" v-model="moneyboxAmount" disabled>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="form-check-label" for="charge">Начислить:</label>
                        <input type="text" class="form-control" :class="{ 'is-invalid': error }" id="charge" name="charge" v-model="moneyboxCharge" :disabled=disabled>
                        <template v-if="error">
                            <div class="invalid-feedback">
                                Недостаточно средств в копилке. Введите корректную сумму.
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="text-center">
                <button type="button" class="btn-cancel" @click="closeModal" >Отмена</button>
                <button type="button" class="btn btn-primary" @click="sendMoneybox" :class="{disabled: error }">Ок </button>
            </div>
        </div>
    </modal>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
    name: 'moneybox',
    computed:  {
        ...mapGetters('shift', [
            "shiftInfo",
            "moneyboxEmployee",
            "moneybox"
        ]),
        workers () {
            return this.shiftInfo.workers?this.shiftInfo.workers:[]
        },
        assistants () {
            return this.shiftInfo.assistants?this.shiftInfo.assistants:[]
        },
        moneybox () {
            return this.shiftInfo.moneybox?this.shiftInfo.moneybox:[]
        },
        moneyboxAmount () {
            if (this.moneybox.total_sum - this.moneyboxCharge >= 0) {
                return this.moneybox.total_sum - this.moneyboxCharge;
            } else {
                return this.moneybox.total_sum
            }
        },
      error() {
          return this.moneybox && this.moneyboxCharge ? !(this.moneybox.total_sum - this.moneyboxCharge >= 0) : false
      }

    },
    data() {
        return {
            moneyboxCharge: '',
            disabled: false
        }
    },
    methods: {
        closeModal() {
            this.$modal.hide('moneyboxToEmployeeChargeModal')
        },
        sendMoneybox() {
          const pload = {
            type: this.moneyboxEmployee.chosenType,
            id: this.moneyboxEmployee.chosenId,
            amount: this.moneyboxCharge,
          }
            this.$store.dispatch('shift/detachEmployee', pload).then(() => {
              this.$store.commit('shift/updateMoneyboxEmployee', {'type': '', 'id': '', 'name': ''})
              this.$modal.hide('moneyboxToEmployeeChargeModal')
              location.reload()
            }).catch((e) => {
              console.log('Error', e)
            })

        },
        moneyboxFullCharge () {
            const mastersAlive = this.workers.filter(worker => worker.leaved_at == null);
            const assistantsAlive = this.assistants.filter(assistant => assistant.leaved_at == null);
            if(mastersAlive.length + assistantsAlive.length == 2) {
                this.disabled = true
                this.moneyboxCharge = this.moneyboxAmount
            }
        },
        resetForm () {
            this.moneyboxCharge = ''
            this.$store.commit('shift/updateMoneyboxEmployee', {'type': '', 'id': '', 'name': ''})
        }
    },
    watch: {
      moneyboxCharge(value) {
        if (value > +this.moneybox.total_sum) {
          this.moneyboxCharge = +this.moneybox.total_sum
        }
      }
    },
}
</script>
<style scoped>
    .btn {
        padding: 10px 30px;
        background: linear-gradient(180deg, #C8FA92 0%, #B5E97C 50%);
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
        border-radius: 11px;
        font-size: 20px;
        color: #000;
    }

    .btn-cancel {
        padding: 10px 30px;
        background: linear-gradient(180deg, #cbcec9 0%, #cfd1cc 50%);
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
        border-radius: 11px;
        font-size: 20px;
        color: #000;
    }
</style>
